import { useMutation } from "@tanstack/react-query";
import { uploadFile, deleteFile } from "../services/file";

export const useUploadFileMutation = () => {
  return useMutation({
    mutationFn: uploadFile,
    retry: 0,
  });
};

export const useDeletePostsMutation = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: deleteFile,
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
